import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ExternalEmployeeService} from '../../../services/external-employee.service';
import {Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Option, StaticMethods} from '../../../model/GeneralModels';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-recompense-employee-response',
  templateUrl: './recompense-employee-response.component.html',
  styleUrls: ['./recompense-employee-response.component.css']
})
export class RecompenseEmployeeResponseComponent implements OnInit {
  @Input() id: number;
  @Input() translation: any;
  @Input() status: string;
  @Input() damageAmount: number;
  testReply: boolean;
  acceptReply: boolean;
  testFileFormGroup = this.fb.group({
    requestedFileType: ['', Validators.required]
  });
  acceptFormGroup = this.fb.group({
    input: ['', Validators.required],
    accept: ['', Validators.required]
  });
  @Input() responseStage: string;
  @Input() show: boolean;

  constructor(private fb: FormBuilder, private service: ExternalEmployeeService,
              private router: Router, public settings: AppSettingsService) {
  }

  ngOnInit(): void {
  }

  submitReply(reply: string) {
    console.log('responseStage: ', this.responseStage);
    switch (reply) {
      case 'ACCEPT_FILE':
        if (this.acceptFormGroup.valid && this.acceptFormGroup.controls.input.value > 0) {
          const input = parseInt(this.acceptFormGroup.controls.input.value, 10);
          if (input > this.damageAmount) {
            StaticMethods.showMessage('مبلغ وارد شده بزرگتر از مبلغ درخواستی کاربر');
            this.acceptFormGroup.controls.input.patchValue(null);
          } else {
            this.service.submitReply(this.id, 'RECOMPENSE', reply, this.acceptFormGroup.controls.input.value)
              .subscribe(response => {
                if (response.success) {
                  this.router.navigate([`/external-employee/RECOMPENSE`]);
                }
              });
          }
        }
        break;
      case 'REJECT_FILE':
        this.service.submitReply(this.id, 'RECOMPENSE', reply, null)
          .subscribe(response => {
            if (response.success) {
              this.router.navigate([`/external-employee/RECOMPENSE`]);
            }
          });
        break;
      case 'TEST_FILE':
        if (this.testFileFormGroup.valid) {
          this.service.submitReply(this.id, 'RECOMPENSE', reply, this.testFileFormGroup.controls.requestedFileType.value)
            .subscribe(response => {
              if (response.success) {
                this.router.navigate([`/external-employee/RECOMPENSE`]);
              }
            });
        } else {
          StaticMethods.showMessage('لطفا فیلد نوع مدارک مورد نیاز را پر نمایید');
        }
        break;
      case 'ACCEPT_DOCUMENT':
        if (this.acceptFormGroup.valid && this.acceptFormGroup.controls.input.value > 0) {
          this.service.submitReply(this.id, 'RECOMPENSE', reply, this.acceptFormGroup.controls.input.value)
            .subscribe(response => {
              if (response.success) {
                this.router.navigate([`/external-employee/RECOMPENSE`]);
              }
            });
        }
        break;
      case 'REJECT_DOCUMENT':
        this.service.submitReply(this.id, 'RECOMPENSE', reply, null)
          .subscribe(response => {
            if (response.success) {
              this.router.navigate([`/external-employee/RECOMPENSE`]);
            }
          });
        break;
      case 'TEST_DOCUMENT':
        if (this.testFileFormGroup.valid) {
          this.service.submitReply(this.id, 'RECOMPENSE', reply, this.testFileFormGroup.controls.requestedFileType.value)
            .subscribe(response => {
              if (response.success) {
                this.router.navigate([`/external-employee/RECOMPENSE`]);
              }
            });
        } else {
          StaticMethods.showMessage('لطفا فیلد نوع مدارک مورد نیاز را پر نمایید');
        }
        break;
    }
  }

  setDamageAmount() {
    this.acceptFormGroup.controls.input.patchValue(this.damageAmount);
  }
}
